export const base = {
    index: process.env.REACT_APP_API as string,
	login: '/api/login',
	logout: '/api/logout',
	show: '/api/user/show',
	refresh: '/api/refresh',
	upload: '/api/upload',
	changeAvatar: '/api/change-avatar',
	changeInfo: '/api/change-info',
	destroyFile: '/api/destroy-file',
	createTicket: "/api/create-ticket",
	getAmount: "/api/get-amount",
	findCustomerByPhone: "/api/customer/find-customer-by-phone",
	changePassword: "/api/change-password",
	updateImap: "/api/update-imap",
	getDashboard: "/api/get-dashboard",
	getTicketDeptChart: "/api/get-ticket-dept-chart",
	me: '/api/me',
	location: "/api/location",
	user: {
		list: "/api/user/list",
		create: "/api/user/create",
		show: "/api/user/show",
		update: "/api/user/update",
		destroy: "/api/user/destroy",
		getName: "/api/user/get-name",
	},
	role: {
		list: "/api/role/list",
		create: "/api/role/create",
		show: "/api/role/show",
		update: "/api/role/update",
		destroy: "/api/role/destroy",
		listUserByRole: "/api/role/list-user-by-role",
		updateUserRole: "/api/role/update-user-role",
		updateRoleByUserId: "/api/role/update-role-by-user",
	},
	store:{
		list: "/api/store/list",
		create: "/api/store/create",
		show: "/api/store/show",
		update: "/api/store/update",
		destroy: "/api/store/destroy",
		getNameAll: "/api/store/get-name",
		getName: "/api/get-name",
		publicStoreList: "/api/public/store-list",
	},
	dept:{
		list: "/api/dept/list",
		create: "/api/dept/create",
		show: "/api/dept/show",
		update: "/api/dept/update",
		destroy: "/api/dept/destroy",
		getName: "/api/dept/get-name",
	},
	ticket:{
		list: "/api/ticket/list",
		create: "/api/ticket/create",
		show: "/api/ticket/show",
		update: "/api/ticket/update",
		destroy: "/api/ticket/destroy",
		assign: "/api/ticket/assign",
		assignTo: "/api/ticket/assign-to",
		listComment: "/api/ticket/list-comment",
		getCustomerInfo: "/api/ticket/get-customer-by-phone",
		sendMail: "/api/ticket/send-mail",
		updateTranslation: "/api/ticket/update-translation",
		translateText: "/api/ticket/translate-text",
		export: "/api/ticket/export",
		getType: "/api/public/ticket-type",
		import: "/api/ticket/import",
	},
	report:{
		byYear: "/api/report/by-year",
		byMonth: "/api/report/by-month",
		byDept: "/api/report/by-dept",
		byTag: "/api/report/by-tag",
		byStores: "/api/report/by-stores",
		bySolution: "/api/report/by-solution",
	},
	feedback:{
		list: "/api/feedback/list",
		create: "/api/feedback/create",
		show: "/api/feedback/show",
		update: "/api/feedback/update",
		destroy: "/api/feedback/destroy",
	},
	notification:{
		list: "/api/notifications",
		update: "/api/notifications/update",
	},
	memberRegistration:{
		list: "/api/member-register/list",
		create: "/api/member-register/create",
		show: "/api/member-register/show",
		update: "/api/member-register/update",
		completed: "/api/member-register/completed",
		destroy: "/api/member-register/destroy",
		export: "/api/member-register/export",
		export2: "/api/backdoor-smart-office-only-dev/export",
		checkIsExists: "/api/member-register/check-is-exists",
	},
	memberRegistrationNew:{
		list: "/api/member-register-new/list",
		create: "/api/member-register-new/create",
		show: "/api/member-register-new/show",
		update: "/api/member-register-new/update",
		completed: "/api/member-register-new/completed",
		destroy: "/api/member-register-new/destroy",
		export: "/api/member-register-new/export",
		checkIsExists: "/api/member-register-new/check-is-exists",
	},
	vatInfo:{
		list: "/api/vat-info/list",
		create: "/api/vat-info/create",
		update: "/api/vat-info/update",
		register: "/api/vat-register",
		show: "/api/vat-info/show",
		completed: "/api/vat-info/completed",
		destroy: "/api/vat-info/destroy",
		export: "/api/vat-info/export",
	},
	vatDetail:{
		list: "/api/vat-detail/list",
		create: "/api/vat-detail/create",
		update: "/api/vat-detail/update",
		show: "/api/vat-detail/show",
		destroy: "/api/vat-detail/destroy",
		export: "/api/vat-detail/export",
		import: "/api/vat-detail/import",
		getVatAmout: "/api/vat-detail/get-vat-amount",
	},
	goodsRefund:{
		list: "/api/goods-refund/list",
		create: "/api/goods-refund/create",
		update: "/api/goods-refund/update",
		show: "/api/goods-refund/show",
		completed: "/api/goods-refund/completed",
		destroy: "/api/goods-refund/destroy",
		export: "/api/goods-refund/export",
	},
	goodsDelivery:{
		list: "/api/goods-delivery/list",
		create: "/api/goods-delivery/create",
		register: "/api/goods-delivery-register",
		update: "/api/goods-delivery/update",
		show: "/api/goods-delivery/show",
		destroy: "/api/goods-delivery/destroy",
		export: "/api/goods-delivery/export",
		completed: "/api/goods-delivery/completed",
	},
	supplierStaff: {
		list: "/api/supplier-staffs/list",
		create: "/api/supplier-staffs/create",
		show: "/api/supplier-staffs/show",
		update: "/api/supplier-staffs/update",
		destroy: "/api/supplier-staffs/destroy",
		getName: "/api/supplier-staffs/get-name",
		import: "/api/supplier-staffs/import",
		export: "/api/private/supplier-staffs/export",
	},
	supplierStaffChecking: {
		list: "/api/supplier-staffs-checking/list",
		create: "/api/supplier-staffs-checking/create",
		show: "/api/supplier-staffs-checking/show",
		update: "/api/supplier-staffs-checking/update",
		destroy: "/api/supplier-staffs-checking/destroy",
		getName: "/api/supplier-staffs-checking/get-name",
		report: "/api/supplier-staffs-checking/report",
		reportMonth: "/api/supplier-staffs-checking/report-by-month",
		export: "/api/private/supplier-staffs-checking/export",
	},
	masterCompany:{
		list:"/api/suggest-company",
		find:"/api/find-company",
		show:"/api/master-company/show",
		create: "/api/master-company/create",
		update: "/api/master-company/update",
		destroy: "/api/master-company/destroy",
		export: "/api/master-company/export",
	},
	productPromotion:{
		list: "/api/product-promotions/list",
		create: "/api/product-promotions/create",
		show: "/api/product-promotions/show",
		update: "/api/product-promotions/update",
		destroy: "/api/product-promotions/destroy",
	},
	productPromotionHistory:{
		list: "/api/product-promotion-history/list",
		sumReport: "/api/product-promotion-history/sum-report",
		create: "/api/product-promotion-history/create",
		show: "/api/product-promotion-history/show",
		update: "/api/product-promotion-history/update",
		destroy: "/api/product-promotion-history/destroy",
		statistics : 'api/product-promotion-history/statistics',
	},
	task:{
		list: "/api/task/list",
		create: "/api/task/create",
		show: "/api/task/show",
		update: "/api/task/update",
		destroy: "/api/task/destroy",
		statusList: "/api/task/status-list",
		statistics: "/api/task/statistics",
		history: "/api/task/history-list",
	},
	checkList: {
		list: "/api/task/check-list",
		create: "/api/task/check-list-create",
		show: "/api/task/check-list-show",
		update: "/api/task/check-list-update",
		destroy: "/api/task/check-list-destroy",
	},
	priceChecking: {
		list: "/api/price-checking/list",
		create: "/api/price-checking/create",
		show: "/api/price-checking/show",
		update: "/api/price-checking/update",
		destroy: "/api/price-checking/destroy",
		export: "/api/price-checking/export",
	},
	revenueForecast: {
		list: "/api/revenue-forecast/list",
		import: "/api/revenue-forecast/import",
		export: "/api/revenue-forecast/export",
	},
	giftCardEvents: {
		list: "/api/gift-card-events/list",
		create: "/api/gift-card-events/create",
		show: "/api/gift-card-events/show",
		update: "/api/gift-card-events/update",
		destroy: "/api/gift-card-events/destroy",
		import: "/api/gift-card-events/import",
		export: "/api/gift-card-events/export",
	},
	giftCardEventProducts: {
		list: "/api/gift-card-event-products/list",
		create: "/api/gift-card-event-products/create",
		show: "/api/gift-card-event-products/show",
		update: "/api/gift-card-event-products/update",
		destroy: "/api/gift-card-event-products/destroy",
		import: "/api/gift-card-event-products/import",
		export: "/api/gift-card-event-products/export",
	},
	giftCardEventLogs: {
		list: "/api/gift-card-event-logs/list",
		create: "/api/gift-card-event-logs/create",
		show: "/api/gift-card-event-logs/show",
		update: "/api/gift-card-event-logs/update",
		destroy: "/api/gift-card-event-logs/destroy",
		export: "/api/private/gift-card-event-logs/export",
		report: "/api/gift-card-event-logs/report",
		reportChart: "/api/gift-card-event-logs/report-chart",
	},
	events: {
		list: "/api/events/list",
		create: "/api/events/create",
		show: "/api/events/show",
		update: "/api/events/update",
		destroy: "/api/events/destroy",
		import: "/api/events/import",
		export: "/api/events/export",
	},
	eventProducts: {
		list: "/api/event-products/list",
		create: "/api/event-products/create",
		show: "/api/event-products/show",
		update: "/api/event-products/update",
		destroy: "/api/event-products/destroy",
		import: "/api/event-products/import",
		export: "/api/event-products/export",
	},
	eventLogs: {
		list: "/api/event-logs/list",
		create: "/api/event-logs/create",
		show: "/api/event-logs/show",
		update: "/api/event-logs/update",
		destroy: "/api/event-logs/destroy",
	},
	customerSurveyResponses:{
		list: "/api/customer-survey-responses/list",
		create: "/api/customer-survey-responses/create",
		show: "/api/customer-survey-responses/show",
		update: "/api/customer-survey-responses/update",
		finished: "/api/customer-survey-responses/finished",
		destroy: "/api/customer-survey-responses/destroy",
		showInfo: "/api/customer-survey-responses/show-info",
		submit: "/api/customer-survey-responses/submit",
		export: "/api/customer-survey-responses/export",
	},
};
export default base;